import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Quiz from "./components/Quiz";
import PlanPage from "./components/PlanPage";
import SuccessPage from "./components/SuccessPage";
import TestGeneratePlan from "./components/TestGeneragePlan";
import Terms from "./components/terms";
import Privacy from "./components/privacy";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/quiz" element={<Navigate to="/quiz/step/0" replace />} />
        <Route path="/quiz/step/:stepId" element={<Quiz />} />
        <Route path="/plan/:planId" element={<PlanPage />} />
        <Route path="/success/:planId" element={<SuccessPage />} />
        <Route path="/test-generate" element={<TestGeneratePlan />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </BrowserRouter>
  );
}
